module.exports = __webpack_public_path__ + "img/home-3.8f0cb789.png";